import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Container,
  Grid,
  Card,
  CardMedia,
  Typography,
  Alert,
  Box,
  Skeleton,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";
import Platform from "../Platform/Platform";
import SessionSlider from "./SessionSlider";
import axios from "axios"

/* ================= CONFIG ================= */
const API_URL = `${process.env.REACT_APP_API_URL}/list_posted_data/`;
const CARD_ASPECT_RATIO = 16 / 9; // width / height
const CARD_MAX_WIDTH = 320;
const CARD_MAX_HEIGHT = 200;
const PAGE_LIMIT = 8; // number of sessions per fetch

/* ================= SESSION CARD ================= */
const SessionCard = ({ session }) => {
  const { loggedIn } = useAuth();
  const videoRef = useRef(null);
   console.log("MEDIA URL FROM API:", session.media_url);

  const isBundle = session.is_bundle;
  const destinationPath = isBundle
    ? `/bundle-detail/${session.id}`
    : `/post-tab-details/${session.id}`;
  const fullPathWithQuery = `${destinationPath}?isBundle=${isBundle}`;
  const linkTo = loggedIn
    ? fullPathWithQuery
    : `/login?redirect=${encodeURIComponent(fullPathWithQuery)}`;

  // const handleMouseEnter = () => {
  //   if (session.media_type === "video" && videoRef.current) videoRef.current.play();
  // };

  // const handleMouseLeave = () => {
  //   if (session.media_type === "video" && videoRef.current) {
  //     videoRef.current.pause();
  //     videoRef.current.currentTime = 0;
  //   }
  // };


  const handleMouseEnter = () => {
  if (session.media_type === "video" && videoRef.current) {
    // Only try to play if the video is currently paused
    if (videoRef.current.paused) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // Ignore "interrupted by pause" or other non-critical errors
          console.log("Video play interrupted:", error);
        });
      }
    }
  }
};

const handleMouseLeave = () => {
  if (session.media_type === "video" && videoRef.current) {
    // Only pause if video is currently playing
    if (!videoRef.current.paused) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }
};

  return (
    <Link to={linkTo} style={{ textDecoration: "none", color: "inherit" }}>
      <Card
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          position: "relative",
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: "#000",
          cursor: "pointer",
          transition: "transform 0.3s ease",
          "&:hover": { transform: "scale(1.03)" },
          "&:hover .overlay": { opacity: 1 },
          display: "flex",
          flexDirection: "column",
          aspectRatio: `${CARD_ASPECT_RATIO}`,
          maxWidth: CARD_MAX_WIDTH,
          maxHeight: CARD_MAX_HEIGHT,
          width: "100%",
        }}
      >
       
        {session.media_type === "video" ? (
          <video
            ref={videoRef}
            src={session.media_url}
            muted
            loop
            preload="metadata"
            style={{ width: "100%", height: "100%", objectFit: "contain", flexGrow: 1 }}
            
          />
        ) : (
          <CardMedia
            component="img"
            image={session.media_url}
            alt={session.highlightedTopic}
            sx={{ width: "100%", height: "100%", objectFit: "cover", flexGrow: 1 }}
          />
        )}

        <Box
          className="overlay"
          sx={{
            position: "absolute",
            inset: 0,
            opacity: 0,
            transition: "opacity 0.3s ease",
            background: "linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.2))",
            display: "flex",
            alignItems: "flex-end",
            p: 2,
            pointerEvents: "none",
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: "#fff", fontWeight: 600, fontSize: { xs: "0.95rem", sm: "1.05rem" } }}
          >
            {session.highlightedTopic}
          </Typography>
        </Box>
      </Card>
    </Link>
  );
};

/* ================= SKELETON CARD ================= */
const SessionSkeleton = () => (
  <Card
    sx={{
      borderRadius: 2,
      bgcolor: "#111",
      aspectRatio: `${CARD_ASPECT_RATIO}`,
      maxWidth: CARD_MAX_WIDTH,
      maxHeight: CARD_MAX_HEIGHT,
      width: "100%",
    }}
  >
    <Skeleton variant="rectangular" animation="wave" sx={{ width: "100%", height: "100%" }} />
    <Box sx={{ p: 2 }}>
      <Skeleton width="80%" height={24} />
    </Box>
  </Card>
);

// /* ================= MAIN LIST ================= */
// const SessionsList = () => {
//   // const { loggedIn } = useAuth();
//   const [sessions, setSessions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadingMore, setLoadingMore] = useState(false);
//   const [error, setError] = useState("");
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const {loggedIn}=useAuth();
//   const [status, setStatus] = useState("Upcoming");
//     const { userId } = useAuth();
  

//   // const fetchSessions = useCallback(async (pageNumber) => {
//   //   try {
//   //     const res = await fetch(`${API_URL}?page=${pageNumber}&limit=${PAGE_LIMIT}`);
//   //     if (!res.ok) throw new Error("Failed to fetch sessions");
//   //     const data = await res.json();
//   //     if (data.length < PAGE_LIMIT) setHasMore(false);
//   //     setSessions((prev) => [...prev, ...data]);
//   //   } catch (err) {
//   //     setError(err.message);
//   //   }
//   // }, []);
// //   const fetchSessions = useCallback(async (pageNumber) => {
// //   try {

// //     const accessToken = localStorage.getItem("access");

// //     const res = await fetch(
// //       `${API_URL}?page=${pageNumber}&limit=${PAGE_LIMIT}`,
// //       {
// //         method: "GET",
// //         headers: {
// //           "Content-Type": "application/json",
// //           Authorization: `Bearer ${accessToken}`,
// //         },
// //       }
// //     );

// //     if (res.status === 401) {
// //       throw new Error("Unauthorized. Please login again.");
// //     }

// //     if (!res.ok) {
// //       throw new Error("Failed to fetch sessions");
// //     }

// //     const data = await res.json();

// //     if (data.length < PAGE_LIMIT) setHasMore(false);
// //     setSessions((prev) => [...prev, ...data]);
// //   } catch (err) {
// //     setError(err.message);
// //   }
// // }, []);



// const fetchSessions = useCallback(async (pageNumber) => {
//   try {
//     const token =
//       localStorage.getItem("access_token") ||
//       localStorage.getItem("auth_token");

//     const res = await fetch(
//   `${API_URL}?page=${pageNumber}&limit=${PAGE_LIMIT}&status=${status}`,
//   {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   }
// );

//     if (res.status === 401) {
//       throw new Error("Unauthorized");
//     }

//     if (!res.ok) {
//       throw new Error("Failed to fetch sessions");
//     }

//     const data = await res.json();

//     if (data.length < PAGE_LIMIT) setHasMore(false);
//     if (pageNumber === 1) {
//   setSessions(data);
// } else {
//   setSessions((prev) => [...prev, ...data]);
// }
//   } catch (err) {
//     console.error("Failed to fetch sessions", err);
//     setError(err.message);
//   }
// }, [status]);

//   useEffect(() => {
//     setLoading(true);
//     fetchSessions(1).then(() => setLoading(false));
//   }, [fetchSessions,status]);

// useEffect(() => {
//   if (page === 1) return;
//   fetchSessions(page).finally(() => setLoadingMore(false));
// }, [page, fetchSessions]);

// // useEffect(() => {
// //   const dummySessions = [
// //     {
// //       id: 1,
// //       highlightedTopic: "Live React Masterclass",
// //       media_type: "video",
// //       media_url: "https://www.w3schools.com/html/mov_bbb.mp4",
// //       is_bundle: false,
// //     },
// //     {
// //       id: 2,
// //       highlightedTopic: "Machine Learning Live Session",
// //       media_type: "image",
// //       media_url: "https://images.unsplash.com/photo-1677442136019-21780ecad995",
// //       is_bundle: false,
// //     },
// //     {
// //       id: 3,
// //       highlightedTopic: "System Design Deep Dive",
// //       media_type: "image",
// //       media_url: "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
// //       is_bundle: false,
// //     },
// //     {
// //       id: 4,
// //       highlightedTopic: "DSA Crash Course",
// //       media_type: "video",
// //       media_url: "https://www.w3schools.com/html/movie.mp4",
// //       is_bundle: false,
// //     },
// //   ];

// //   setSessions(dummySessions);
// //   setLoading(false);
// // }, []);  // Infinite scroll
//   useEffect(() => {
//     if (!hasMore) return;
//     const handleScroll = () => {
//       if (
//         window.innerHeight + window.scrollY >=
//         document.documentElement.scrollHeight - 300
//       ) {
//         if (!loadingMore) {
//           setLoadingMore(true);
//           setPage((prev) => prev + 1);
//         }
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [loadingMore, hasMore]);

//   // useEffect(() => {
//   //   if (page === 1) return;
//   //   fetchSessions(page).then(() => setLoadingMore(false));
//   // }, [page, fetchSessions]);

//   return (
//     <>
//       <Box sx={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1300 }}>
//         <Header1 />
//       </Box>


//       {loggedIn && <Platform />}

//       <Box sx={{ bgcolor: "#000", minHeight: "100vh", py: { xs: 6, md: 8 } }}>
//         <SessionSlider/>
//         <Container maxWidth="xl">
//           <Typography
//   variant="h4"
//   sx={{
//     color: "#fff",
//     fontWeight: 700,
//     mb: 4,
//     mt:4,
//     fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2rem" },
//     textAlign: "center", // ✅ Center aligned
//   }}
// >
//   Trending Sessions
// </Typography>

// <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
//   <Tabs
//     value={status}
//     onChange={(e, newValue) => {
//       setStatus(newValue);
//       setSessions([]);
//       setPage(1);
//       setHasMore(true);
//     }}
//   >
//     <Tab label="Upcoming" value="Upcoming" />
//     <Tab label="Live" value="Live" />
//     <Tab label="Completed" value="Completed" />
//   </Tabs>
// </Box>


//           {error && (
//             <Alert severity="error" sx={{ mb: 3 }}>
//               {error}
//             </Alert>
//           )}

//           <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} justifyContent="center">
//             {sessions.map((session) => (
//               <Grid
//                 item
//                 xs={12}
//                 sm={6}
//                 md={4}
//                 lg={3}
//                 key={session.id}
//                 display="flex"
//                 justifyContent="center"
//               >
//                 <SessionCard session={session} />
//               </Grid>
//             ))}

//             {loading &&
//               Array.from(new Array(PAGE_LIMIT)).map((_, index) => (
//                 <Grid
//                   item
//                   xs={12}
//                   sm={6}
//                   md={4}
//                   lg={3}
//                   key={index}
//                   display="flex"
//                   justifyContent="center"
//                 >
//                   <SessionSkeleton />
//                 </Grid>
//               ))}

//             {loadingMore &&
//               Array.from(new Array(PAGE_LIMIT)).map((_, index) => (
//                 <Grid
//                   item
//                   xs={12}
//                   sm={6}
//                   md={4}
//                   lg={3}
//                   key={`loading-${index}`}
//                   display="flex"
//                   justifyContent="center"
//                 >
//                   <SessionSkeleton />
//                 </Grid>
//               ))}
//           </Grid>
//         </Container>
//       </Box>

//       <Footer2 />
//     </>
//   );
// };

// export default SessionsList;

const SessionsList = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const { loggedIn } = useAuth();
  const [status, setStatus] = useState("Upcoming");

  /* ✅ FIXED: fetch without useCallback dependency loop */
  const fetchSessions = async (pageNumber, currentStatus) => {
    try {
      const token =localStorage.getItem("access_token")
        // localStorage.getItem("access_token") ||
        // localStorage.getItem("auth_token");

      if (!token) {
  setError("Please login again");
  return;
}

      const res = await fetch(
        `${API_URL}?page=${pageNumber}&limit=${PAGE_LIMIT}&status=${currentStatus}&type=session`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.status === 401) {
  localStorage.clear();
  window.location.href = "/login";
  return;
}
      if (!res.ok) throw new Error("Failed to fetch sessions");

      const data = await res.json();

      if (data.length < PAGE_LIMIT) setHasMore(false);

      if (pageNumber === 1) {
        setSessions(data);
      } else {
        // ✅ prevent duplicates
        setSessions((prev) => {
          const newData = data.filter(
            (item) => !prev.some((p) => p.id === item.id)
          );
          return [...prev, ...newData];
        });
      }
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  /* ✅ FIRST LOAD + TAB CHANGE */
  useEffect(() => {
    setLoading(true);
    setSessions([]);
    setPage(1);
    setHasMore(true);

    fetchSessions(1, status).then(() => setLoading(false));
  }, [status]);

  /* ✅ PAGINATION (chunking preserved) */
  useEffect(() => {
    if (page === 1) return;

    fetchSessions(page, status).finally(() => setLoadingMore(false));
  }, [page]);

  /* ✅ INFINITE SCROLL */
  useEffect(() => {
    if (!hasMore) return;

    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 300
      ) {
        if (!loadingMore) {
          setLoadingMore(true);
          setPage((prev) => prev + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loadingMore, hasMore]);

  return (
    <>
      <Box sx={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1300 }}>
        <Header1 />
      </Box>

      {loggedIn && <Platform />}

      <Box sx={{ bgcolor: "#000", minHeight: "100vh", py: { xs: 6, md: 8 } }}>
        <SessionSlider />

        <Container maxWidth="xl">
          <Typography
            variant="h4"
            sx={{
              color: "#fff",
              fontWeight: 700,
              mb: 4,
              mt: 4,
              textAlign: "center",
            }}
          >
            Trending Sessions
          </Typography>

          {/* ✅ Tabs */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <Tabs
              value={status}
              onChange={(e, newValue) => setStatus(newValue)}
            >
              <Tab label="Upcoming" value="Upcoming" />
              <Tab label="Live" value="Live" />
              <Tab label="Completed" value="Completed" />
            </Tabs>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}

          <Grid container spacing={3} justifyContent="center">
            {sessions.map((session) => (
              <Grid item key={session.id}>
                <SessionCard session={session} />
              </Grid>
            ))}

            {/* ✅ Initial loading */}
            {loading &&
              Array.from(new Array(PAGE_LIMIT)).map((_, i) => (
                <Grid item key={i}>
                  <SessionSkeleton />
                </Grid>
              ))}

            {/* ✅ Infinite scroll loading */}
            {loadingMore &&
              Array.from(new Array(PAGE_LIMIT)).map((_, i) => (
                <Grid item key={`load-${i}`}>
                  <SessionSkeleton />
                </Grid>
              ))}
          </Grid>
        </Container>
      </Box>

      <Footer2 />
    </>
  );
};
export default SessionsList;